import { render, staticRenderFns } from "./BulletInListComponent.vue?vue&type=template&id=6f21ce8e&scoped=true"
import script from "./BulletInListComponent.vue?vue&type=script&lang=js"
export * from "./BulletInListComponent.vue?vue&type=script&lang=js"
import style0 from "./BulletInListComponent.vue?vue&type=style&index=0&id=6f21ce8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f21ce8e",
  null
  
)

export default component.exports